import React, { createContext, FC, MouseEvent, useContext, useMemo } from 'react';
import { ReframeDirection } from '@/GraphEditor/drawingLayer/useNodeResizing';

export const NodeReframeContext = createContext<{
    startNodeReframe: (event: MouseEvent, direction: ReframeDirection) => void;
    endNodeReframe: () => void;
}>({
    startNodeReframe: () => {},
    endNodeReframe: () => {},
});

interface NodeReframeContextProviderProps {
    startNodeReframe: (event: MouseEvent, direction: ReframeDirection) => void;
    endNodeReframe: () => void;

    children: React.ReactNode;
}

export const NodeReframeContextProvider: FC<NodeReframeContextProviderProps> = props => {
    const value = useMemo(
        () => ({
            startNodeReframe: props.startNodeReframe,
            endNodeReframe: props.endNodeReframe,
        }),
        [props.startNodeReframe, props.endNodeReframe],
    );
    return <NodeReframeContext.Provider value={value}>{props.children}</NodeReframeContext.Provider>;
};

export function useNodeReframe() {
    return useContext(NodeReframeContext);
}
